import axios from 'axios';
import moment from 'moment';

const goShareEstimatHandler = async ({
	batch,
	location,
	coordinates,
	address,
	buyer,
	seller,
}) => {
	try {
		let vehicle =
			batch.listings.length === 1
				? batch.listings[0].listing.delivery.vehicle
				: 'pickup_truck';

		let subProjects = [
			{
				vehicle,
				equipment: [],
			},
		];

		let items = [];

		for (let listing of batch.listings) {
			items.push({
				quantity: listing.quantity,
				id: listing.listing.delivery.item.id,
			});
		}

		if (
			batch.listings.length === 1 &&
			batch.listings[0].listing.delivery.helpers === 2
		) {
			subProjects.push({ vehicle: 'helper' });
		}

		let dropAddress = {
			postCode: '',
			place: '',
			district: '',
			region: '',
			country: '',
		};
		let pickupAddress = {
			postCode: '',
			place: '',
			district: '',
			region: '',
			country: '',
		};

		if (location?.context) {
			for (let ob of location.context) {
				if (ob.id.includes('postcode')) {
					dropAddress.postCode = ob.text;
				}
				if (ob.id.includes('place')) {
					dropAddress.place = ob.text;
				}
				if (ob.id.includes('district')) {
					dropAddress.district = ob.text;
				}
				if (ob.id.includes('region')) {
					dropAddress.region = ob.short_code.slice(3);
				}
				if (ob.id.includes('country')) {
					dropAddress.country = ob.short_code;
				}
			}
		}

		if (batch.listings[0].listing?.delivery?.location?.context) {
			for (let ob of batch.listings[0].listing.delivery.location.context) {
				if (ob.id.includes('postcode')) {
					pickupAddress.postCode = ob.text;
				}
				if (ob.id.includes('place')) {
					pickupAddress.place = ob.text;
				}
				if (ob.id.includes('district')) {
					pickupAddress.district = ob.text;
				}
				if (ob.id.includes('region')) {
					pickupAddress.region = ob.short_code.slice(3);
				}
				if (ob.id.includes('country')) {
					pickupAddress.country = ob.short_code;
				}
			}
		}

		let startDateTime = moment()
			.add(1, 'day')
			.set('hour', 16)
			.set('minute', 0)
			.format('YYYY-MM-DD kk:mm:ss');

		const body = JSON.stringify({
			startDateTime,
			subProjects,
			stops: [
				{
					sequence: 1,
					place: {
						address: {
							street: batch.listings[0].listing.delivery.address,
							country: 'United States',
							state: pickupAddress.region,
							city: pickupAddress.place,
						},
						coordinates: {
							latitude: batch.listings[0].listing.delivery.coordinates[1],
							longitude: batch.listings[0].listing.delivery.coordinates[0],
						},
						contact: {
							name: seller?.firstName ? seller.firstName : 'Bobby',
							phone: batch.listings[0].listing.delivery.phone,
						},
						hasElevator: batch.listings[0].listing.delivery.elevator,
						flightOfStairs: batch.listings[0].listing.delivery.flights,
						additionalInformation: batch.listings[0].listing.delivery.otherInfo,
					},
					pickupItems: items,
					dropOffItems: [],
				},
				{
					sequence: 2,
					place: {
						address: {
							street: address,
							country: 'United States',
							state: dropAddress.region,
							city: dropAddress.place,
						},
						coordinates: {
							latitude: coordinates[1],
							longitude: coordinates[0],
						},
						contact: {
							name: buyer?.firstName ? buyer.firstName : 'Kashew',
							phone: buyer?.phone ? buyer.phone : '2135581019',
						},
						hasElevator: false,
						flightOfStairs: 0,
						additionalInformation: '',
					},
					pickupItems: [],
					dropOffItems: items,
				},
			],
		});

		return await axios
			.post(`${process.env.NEXT_PUBLIC_SERVER_API}/api/api/goshare/estimate`, {
				body: body,
			})
			.then((res) => {
				let data = { ...res.data.data, body };

				return data;
			})
			.catch((error) => {
				return null;
			});
	} catch (error) {
		return error;
	}
};

export default goShareEstimatHandler;
